export default __webpack_public_path__ + "static/18-988383ebbb54989de9887288926afaa0.jpg";